import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import pages from './routes/pages'
import basic from './routes/basic'
import advance from  './routes/advance'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { 
      path: '', 
      name: 'hom', 
      component : () => import("@/components/Home.vue"),
      meta: {
        layout: 'boxed',
      }
    },
    { 
      path: '/', 
      name: 'home', 
      component : () => import("@/components/Home.vue"),
      meta: {
        layout: 'boxed',
      }
    }, 
    
    ...pages,
    ...basic,
    ...advance,
    {
      path: '*',
      redirect: '/',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn)  return next({ name: 'auth-login' })

    // If logged in => not authorized
    //return next({ name: 'misc-not-authorized' })
  }
  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    //console.log(userData)
    return next({ name: 'home' })
    //next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
